import {INICIALIZED_SUCCESS, TOGGLE_ACTIVE_LEFT_MENU, SET_MESSENGERS_LIST, SET_SAVING_STATUS} from "./constans";
import {getUser} from "../user/actions";
import {getObjectsList} from "../../components/Objects/actions";
import {appAPI} from "../../API/API";


export const inicializedSuccess = () => {
    return {
        type: INICIALIZED_SUCCESS,
    }
};
export const toggleActiveLeftMenu = (active) => {
    return {
        type: TOGGLE_ACTIVE_LEFT_MENU,
        active
    }
};

export const setMessengersList = (messengers) => {
    return {
        type: SET_MESSENGERS_LIST,
        messengers
    }

};

export const setSavingStatus = (payload) => {
    return {
        type: SET_SAVING_STATUS,
        payload
    }

};



export const inicializeApp = () => {
    return async (dispatch) => {
        let userResult, objectsResult

        if (localStorage.getItem("egApiToken")) {
            userResult = await dispatch(getUser())

            if (userResult && userResult.payload.role !== "MODERATOR" && userResult.payload.role !== "ADMIN") {
                objectsResult = await dispatch(getObjectsList())
            }
        }

        Promise.all([userResult, objectsResult])
            .then(() => {
                dispatch(inicializedSuccess());
            })
    };
}





export const toggleLeftMenu = (active) => {
    return (dispatch) => {
        dispatch(toggleActiveLeftMenu(active));
    };
}



export const getMessengersList = () => async (dispatch) => {
    let response = await appAPI.getMessengers();

    if (response.status) {
        dispatch(setMessengersList(response.data))
    }
}

export const updateSavingStatus = (data) => async (dispatch) => {
    dispatch(setSavingStatus(data))
}
